export default __webpack_public_path__ + "static/media/schutzkleidung.85dd0ae0.jpg";